import { render, staticRenderFns } from "./ArchiveCardView.vue?vue&type=template&id=37374b5e&scoped=true&"
import script from "./ArchiveCardView.vue?vue&type=script&lang=js&"
export * from "./ArchiveCardView.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCardView.vue?vue&type=style&index=0&id=37374b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37374b5e",
  null
  
)

export default component.exports